var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame",class:{ large: _vm.bordersize === 'large' }},[_c('div',{staticClass:"side top"}),_vm._v(" "),_c('div',{staticClass:"side left"}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"side right"}),_vm._v(" "),_c('div',{staticClass:"side bottom"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4106668a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Framer.vue
// module id = null
// module chunks = 